import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import Service from "../components/Service/Service";
import Intro from "../sections/Intro/Intro";

const PrivacyPolicy = () => {
  return (
    <div className="column">
      <Header />
      <Intro primary="Privacy Policy" secondary="Updated August 21, 2026" />
      <div className="container privacy-policy">
        <div className="column w64 g1">
          <h3 style={{ margin: 0 }}>1. Information We Collect</h3>
          <p className="ltext">
            We may collect personal information that you voluntarily provide to
            us, including but not limited to:
          </p>
          <ul>
            <Service>Name</Service>
            <Service>Phone number</Service>
            <Service>Email address</Service>
            <Service>
              Any other information you provide when contacting us or signing up
              for services.
            </Service>
          </ul>
          <h3>2. How We Use Your Information</h3>
          <p>We use the information we collect to:</p>
          <ul>
            <Service>Provide and manage our services</Service>
            <Service>
              Communicate with you, including responding to inquiries
            </Service>
            <Service>
              Send notifications, updates, and reminders related to our services
            </Service>
            <Service>Improve our services and customer experience</Service>
          </ul>
          <h3>3. Information Sharing</h3>
          <p>
            We do not share, sell, rent, or disclose your personal information
            to third parties for marketing purposes. We may share information
            only as necessary to:
          </p>
          <ul>
            <Service>Comply with applicable laws or regulations</Service>
            <Service>Enforce our policies or protect our rights</Service>
          </ul>
          <p>
            Mobile information will not be shared with third parties/affiliates
            for marketing/ promotional purposes. All the above categories
            exclude text messaging originator opt-in data and consent; this
            information will not be shared with any third parties.
          </p>
          <h3>4. SMS Communications & Mobile Terms and Conditions</h3>
          <p>
            By opting in to receive SMS messages from us, you agree to the
            following terms:
          </p>
          <h4>Message Types</h4>
          <p>
            After opting in, you may receive SMS messages including, but not
            limited to:
          </p>
          <ul>
            <Service>
              <p>Appointment notifications</p>
            </Service>
            <Service>
              <p>Follow-ups</p>
            </Service>
            <Service>Service-related updates</Service>
          </ul>
          <h4>Message Frequency</h4>
          <p>
            Message frequency may vary depending on your interactions with us.
          </p>
          <h4>Message & Data Rates</h4>
          <p>
            Message and data rates may apply for any messages sent to you from
            us and to us from you. For questions about your text or data plan,
            please contact your wireless provider.
          </p>
          <h4>Opt-Out Instructions</h4>
          <p>
            You can cancel the SMS service at any time by texting “STOP.” After
            you send “STOP,” you will receive a confirmation message that you
            have been unsubscribed. After this, you will no longer receive SMS
            messages from us. To rejoin, simply sign up again as you did
            initially.
          </p>
          <h4>Help Instructions</h4>
          <p>
            If you are experiencing issues with the messaging program, you can
            reply with “HELP” for assistance, or contact us directly at
            <strong> info@crystal-clear-consulting.com</strong>.
          </p>
          <h4>Carrier Disclaimer</h4>
          <p>Carriers are not liable for delayed or undelivered messages.</p>
          <h3>5. Data Security</h3>
          <p>
            We implement reasonable administrative, technical, and physical
            safeguards to protect your personal information. However, no method
            of transmission over the Internet or electronic storage is 100%
            secure.
          </p>
          <h3>6. Your Rights and Choices</h3> <p>You may:</p>
          <ul>
            <Service>
              Opt out of SMS communications at any time (see above)
            </Service>
            <Service>Contact us to update or correct your information</Service>
          </ul>
          <h3>7. Third-Party Links</h3>
          <p>
            Our services may contain links to third-party websites. We are not
            responsible for the privacy practices of those sites.
          </p>
          <h3>8. Changes to This Policy</h3>
          <p>
            We may update this Privacy Policy from time to time. Any changes
            will be posted with an updated effective date.
          </p>
          <h3>9. Contact Us</h3>
          <p>
            If you have any questions about this Privacy Policy or our
            practices, please contact us:
          </p>
          <a
            className="secondary"
            href="mailto:info@crystal-clear-consulting.com"
          >
            info@crystal-clear-consulting.com
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
